let setCargoCarriers = (state, cargoCarriersDto) => {
	state.cargoCarriers = cargoCarriersDto;
};

function set(state, fn) {
	if (fn)
		fn(state);
}

function setErrors(state, { errors, id }) {
	if (!errors) return;

	state.errors.palletCapacity = errors.invalidPalletCapacity || false;
	state.errors.volume = errors.invalidVolume || false;
	state.errors.weight = errors.invalidWeight || false;
	state.errors.loadingMeters = errors.invalidLoadingMeters || false;
	state.errors.iconId = errors.invalidIconId || false;
	state.errors.id = id ? id : '';
}

function clearErrors(state) {
	state.errors.palletCapacity = false;
	state.errors.volume = false;
	state.errors.weight = false;
	state.errors.loadingMeters = false;
	state.errors.iconId =  false;
	state.errors.id = '';
}

export default {
	setCargoCarriers,
	set,
	setErrors,
	clearErrors
};
